module.exports = __webpack_public_path__ + "img/quicktips20.93e87685.svg";